import Menu from './Menu';

export default Menu;



// WEBPACK FOOTER //
// ./src/shared/components/menu/index.ts